import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import GLOBAL_STYLES from '../../styles/GlobalStyles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        form: {
            maxWidth:"100%",
            marginTop: theme.spacing(5),
            marginBottom: theme.spacing(10),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent:'center',
            margin:"auto",
        },
        imageLarge: {
            width:'150px',
            height:'150px',
            backgroundColor: GLOBAL_STYLES.primaryColor,
            fontSize:'4rem'
        },
        buttonsSection: {
            display:'flex',
            width:'100%',
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            alignItems: 'center',
            justifyContent:'center',
        },
        headerSection: {
            display:'grid',
            gridTemplateColumns:'repeat(3,1fr)',
            width:'100%',
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            alignItems:'center'
        },
        title: {
            justifySelf:'center',
            [theme.breakpoints.down('xs')]:{
                fontSize:'22px'
            }
        },
        arrowBack:{
            width:'24px',
            height:'24px',
            textDecoration:'none',
            color: 'black',
        },
        editButton: {
            width:'100%',
            display:'grid',
            gridTemplateColumns:'repeat(1,1fr)',
            justifyItems:'flex-end',
        },
        messageError: {
            display:'flex',
            height:'65vh',
            justifyContent:'center',
            alignItems:'center',
            padding:'5px',

            '& h2':{
                fontSize:'50px',
                },
        }
    })
);